export const apiUrl = process.env.VUE_APP_API_URL
export const bucketUrl = process.env.VUE_APP_BUCKET_URL
export const appEnv = process.env.VUE_APP_ENV
export const defaultCompanyLogo = process.env.VUE_APP_DEFAULT_COMPANY_LOGO_PATH
